<div class="block">
    <div class="required">
        <label>{{ 'Components.EnterNewPassword.PasswordHeaderText' | translate }}</label>
    </div>

    <input class="form-control"
           name="Password"
           type="password"
           autocomplete="new-password"
           placeholder="{{ 'Components.EnterNewPassword.PasswordPlaceholder' | translate }}"
           [(ngModel)]="passwordValue">
</div>

<div class="block">
    <div class="required">
        <label>{{ 'Components.EnterNewPassword.RepeatPasswordHeaderText' | translate }}</label>
    </div>

    <input class="form-control"
           name="RepeatPassword"
           type="password"
           placeholder="{{ 'Components.EnterNewPassword.RepeatPasswordPlaceholder' | translate }}"
           [(ngModel)]="repeatPasswordValue">

    <span *ngIf="errorText"
          class="text-danger error">
        {{errorText}}
    </span>

    <div *ngIf="regexPasswordRuleList.length > 0"
         class="pt-3">
        <div class="text-muted">
            {{ 'Components.EnterNewPassword.RegexRulesHeader' | translate }}:
        </div>
        <div class="row justify-content-start no-gutters pl-3"
             *ngFor="let passwordRule of regexPasswordRuleList"
             [ngClass]="{
                'text-muted': passwordRule.isError == null,
                'text-success': passwordRule.isError == false,
                'text-danger': passwordRule.isError == true
             }">
                <div class="col-auto">
                    &#9679;
                </div>
                <div class="col pl-2">
                    {{ passwordRule.text }}
                    <div *ngIf="passwordRule.text.includes(defaultPasswordRule)">
                        {{ 'Components.EnterNewPassword.ObligatoryRule' | translate }}
                    </div>
                </div>
        </div>


    </div>

    <div *ngIf="otherPasswordRuleList.length > 0"
         class="pt-3">
        <div class="text-muted">
            {{ 'Components.EnterNewPassword.OtherRulesHeader' | translate }}:
        </div>
        <div class="row justify-content-start no-gutters pl-3"
             *ngFor="let passwordRule of otherPasswordRuleList"
             [ngClass]="{
                'text-muted': passwordRule.isError == null,
                'text-success': passwordRule.isError == false,
                'text-danger': passwordRule.isError == true
             }">
            <div class="col-auto">
                &#9679;
            </div>
            <div class="col pl-2">
                {{ passwordRule.text }}
            </div>
        </div>
    </div>

</div>

<div class="btn-group">
    <button class="btn btn-primary"
            name="Operation"
            type="submit"
            (click)="submitButtonClick($event)">
        {{submitButtonText}}
    </button>
</div>
